(function(){
  function run(){
    var c=window.FLASH_SALE_CONFIG||{};
    if(!c.start||!c.end){return;}
    var S=new Date(c.start),E=new Date(c.end);
    if(isNaN(S)||isNaN(E)){return;}
    var now=new Date(),before=now<S,during=now>=S&&now<E,after=now>=E;
    document.body.classList.add(before?'fs-before':during?'fs-active':'fs-ended');
    function upd(){
      var t=document.querySelectorAll('[data-flash-timer]');if(!t.length)return;
      var base=during?E:(before?S:null);
      if(!base){t.forEach(function(e){e.textContent='--';});return;}
      var diff=base-new Date();
      if(diff<=0){location.reload();return;}
      var d=Math.floor(diff/86400000),h=Math.floor((diff%86400000)/3600000),m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
      var p=function(n){return String(n).padStart(2,'0');};
      t.forEach(function(e){var k=e.dataset.flashTimer;
        if(k==='days')e.textContent=String(d);
        if(k==='hours')e.textContent=p(h);
        if(k==='minutes')e.textContent=p(m);
        if(k==='seconds')e.textContent=p(s);});
    }
    upd();if(before||during)setInterval(upd,1000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else setTimeout(run,80);
})();